import { getApiDataPromise } from "@usher/pe-client-front-end-lib"
import { FilterBase, FormValues } from "./FilterBase"
import { useCallback, useEffect, useState } from "react"
import { useForm } from "react-hook-form"

const getDateFilterString = (d: Date) => {
  if (d == null) return ""

  let result = d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2)
  return result
}

type Props = {
  onFilter: (filter: any) => void
  withPayoutsCards?: boolean
}

export const PayoutsFilter = ({ onFilter, withPayoutsCards }: Props) => {
  const formMethods = useForm<FormValues>({
    defaultValues: {
      status: { value: "0", label: "All" },
      card: { value: "0", label: "All" },
      period: { value: "0", label: "All time" },
      date: [new Date(), new Date()],
    },
  })

  const [options, setOptions] = useState({
    fiat: [{ value: "0", label: "All" }],
    crypto: [{ value: "0", label: "All" }],
    cards: [{ value: "0", label: "All" }],
    status: [{ value: "0", label: "All" }],
    period: [
      { value: "0", label: "All time" },
      { value: "1", label: "Custom" },
    ],
  })

  const handleReset = useCallback(() => formMethods.reset(), [formMethods])

  useEffect(() => {
    getApiDataPromise({}, "exclient/cards", "get_payout_status").then((res) => {
      setOptions((prev) => ({
        ...prev,
        status: [{ value: "0", label: "All" }, ...Object.entries<string>(res.data ?? {}).map(([value, label]) => ({ value, label }))],
      }))
    })

    getApiDataPromise({ card_type: "3" }, "exchange", "get_user_cards").then((res) => {
      setOptions((prev) => ({
        ...prev,
        cards: [{ value: "0", label: "All" }, ...(res.data ?? []).map((card: any) => ({ value: card.id, label: card.card_pan }))],
      }))
    })
  }, [])

  const handleSubmit = useCallback(
    (data: FormValues) => {
      const filter = {
        status: data.status.value,
        card: data.card?.value,
      }

      if (data.period.value === "1") {
        //@ts-ignore
        filter.time_from = getDateFilterString(data.date[0])
        //@ts-ignore
        filter.time_to = getDateFilterString(data.date[1])
      }

      onFilter(filter)
    },
    [onFilter]
  )

  return (
    <FilterBase
      formMethods={formMethods}
      onReset={handleReset}
      onSubmit={handleSubmit}
      options={options}
      withoutExchangeTo
      withPayoutsCards={withPayoutsCards}
    />
  )
}
